import prependParentNode from './prependParentNode';

const loadScript = async (src: string, dataAttributes: DOMStringMap = {}, context: Window = window) =>
    prependParentNode<HTMLScriptElement>(
        'script',
        {
            src,
            async: true,
            type: 'text/javascript',
        },
        dataAttributes,
        context
    );

export default loadScript;
